import { render } from "./VitalsChart.vue?vue&type=template&id=4054eac0&scoped=true"
import script from "./VitalsChart.vue?vue&type=script&lang=js"
export * from "./VitalsChart.vue?vue&type=script&lang=js"

import "./VitalsChart.vue?vue&type=style&index=0&id=4054eac0&scoped=true&lang=css"

import exportComponent from "/home/runner/work/medsien-patient-app/medsien-patient-app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4054eac0"]])

export default __exports__